export enum LocationEnum {
  WAREHOUSE = 1,
  CARBON = 2,
  SERVICE = 3
}
